<template>
  <div>
    <p>
  
    </p>


    <el-table :data="tableData" stripe style="width: 100%"  
    :default-sort = "{prop: 'date', order: 'descending'}">
      <el-table-column prop="date" label="日期" width="110"    sortable>
      </el-table-column>
      <el-table-column prop="activate_today" label="今日激活">
      </el-table-column>
      <el-table-column prop="card_today" label="今日绑卡">
      </el-table-column>


      <el-table-column prop="balance_today" label="今日平衡">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColorBad(scope.row.balance_today) }">{{ scope.row.balance_today }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="activate_total" label="累计激活">
      </el-table-column>
      <el-table-column prop="card_total" label="累计绑卡">
      </el-table-column>


      <el-table-column prop="unlinked_total" label="累计未绑卡">
      </el-table-column>

      <el-table-column prop="days30" label="其中30天内">
      </el-table-column>
      <el-table-column prop="days180" label="31-180天">
      </el-table-column>
      <el-table-column prop="days181" label="181天以上">
      </el-table-column>

      <el-table-column prop="unlinked_device" label="至今未绑卡试用的设备清单"   width="480">
      </el-table-column>
      

    </el-table>




  </div>
</template>
  
<script>



export default {
  data() {
    return {
      tableData: []
    }
  },
  watch: {
    //watch  观察变化, 来自苏驰的优化
    $route(newVal, oldVal) {
      this.getData(newVal.params.bike_type)
    }
  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods:{
    async  getData( bike_type){
      //const bike_type = type;
      this.tableData = []

      let res = await this.$http.get("/da/unlinked_card/"+ bike_type)
      this.tableData = res.data
        console.log(res.data)
    },  
    getBalanceColorBad(value) {
     
      if (value < -0.1) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= -0.1 && value < 0.1) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },  
  },

  mounted: function () {
    //注意回调函数的作用域!!!

    const bike_type = this.$route.params.bike_type;

    this.getData(bike_type)
  }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
  